export default {
    "template": "componentsCompany/astra/CompanySettings",
    "default_number_format": {
        "decimal_point": ",",
        "decimal_length": 2
    },
    "menu_template": "componentsCompany/astra/header/MenuComponent"
}